"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundSelectAndTextField = BoundSelectAndTextField;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const CompoundField_1 = require("../components/internal/CompoundField");
const index_1 = require("./index");
const utils_1 = require("../utils");
const defaultTestId_1 = require("../utils/defaultTestId");
function BoundSelectAndTextField(props) {
    var _a, _b;
    const { selectFieldProps, textFieldProps, compact = true } = props;
    const tid = (0, utils_1.useTestIds)(props);
    return ((0, jsx_runtime_1.jsxs)(CompoundField_1.CompoundField, { children: [(0, jsx_runtime_1.jsx)(index_1.BoundSelectField, { ...tid[(0, defaultTestId_1.defaultTestId)((_a = selectFieldProps.label) !== null && _a !== void 0 ? _a : selectFieldProps.field.key)], ...selectFieldProps, sizeToContent: true, compact: compact }), (0, jsx_runtime_1.jsx)(index_1.BoundTextField, { ...tid[(0, defaultTestId_1.defaultTestId)((_b = textFieldProps.label) !== null && _b !== void 0 ? _b : textFieldProps.field.key)], ...textFieldProps, compact: compact })] }));
}
